import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitCallInfoProps } from '../sectionProps';
import { initialValues, validationSchema } from './formData';

export const useOrbitCallInfo = ({ onChangeFormik }: OrbitCallInfoProps) => {
    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
    });

    return { formik };
};
